import { eachDayOfInterval, format, isSameDay, parse } from "date-fns";

export const parseDay = (v?: string) => (v ? parse(v, "yyyy-MM-dd", new Date()) : undefined);

export function formatRange(start?: string, end?: string) {
  const s = parseDay(start);
  const e = parseDay(end);
  if (!s) return "";
  if (!e || isSameDay(s, e) || e < s) return format(s, "MMM d, yyyy");
  if (s.getFullYear() !== e.getFullYear()) return `${format(s, "MMM d, yyyy")} – ${format(e, "MMM d, yyyy")}`;
  if (s.getMonth() !== e.getMonth()) return `${format(s, "MMM d")} – ${format(e, "MMM d, yyyy")}`;
  return `${format(s, "MMM d")}–${format(e, "d, yyyy")}`;
}

export function eventDays(start?: string, end?: string): Date[] {
  const s = parseDay(start);
  if (!s) return [];
  const e = parseDay(end);
  return e && e > s ? eachDayOfInterval({ start: s, end: e }) : [s];
}
